<template>
  <tbody>
  <tr :class="['clickable', { updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity.id)">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <span
          v-if="!$_updateActionAllowed || (entity.id_remote && $_loggedUser_selectedOperatorId)"
          class="lock"
          :title="'Uzamknuto' | translate"
          v-translate>
      </span>
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label
          :for="entity.id"
          @click.stop
          v-translate>Vybrat
      </label>
    </td>
    <td :data-th="'EPG kanál' | translate" v-if="entity.all_epg_channels.length > 1">
      <span class="dotted">
      <strong>{{ entity.epg_channel }}</strong> (#{{ entity.id_epg }})
         <span class="help_popup" style="min-width: 160px;">
														<strong v-translate>Platí také pro kanály:</strong> <br/> {{ epgChannels }}
													</span>
      </span>
    </td>
    <td :data-th="'EPG kanál' | translate" v-else>
      <strong>{{ entity.epg_channel }}</strong> (#{{ entity.id_epg }})
    </td>
    <td :data-th="'Název' | translate">
      {{ entity.name }}
    </td>
    <td :data-th="'Blokovat od' | translate" v-html="$_date_formatFull(entity.from_timestamp)"></td>
    <td :data-th="'Blokovat do' | translate" v-html="$_date_formatFull(entity.to_timestamp)"></td>
    <td :data-th="'Operátor' | translate">
      <entity-link :id="entity.id_operator" type="operator">{{ entity.operator_name }}</entity-link>
    </td>
    <td :data-th="'Povoleno' | translate">
      <span class="dotted" v-if="entity.enabled_overrides.length > 0 && !$_loggedUser_selectedOperatorId">
      <img class="is_set" src="../../../assets/images/is-set.svg" alt="Ano"
           v-if="entity.enabled"/>
      <img v-else class="is_set" src="../../../assets/images/isnot-set.svg" alt="Ne"/>
        <div class="help_popup" style="min-width: 250px;">
														<strong v-translate>Přetíženo business modely:</strong>
          <div v-for="item in entity.enabled_overrides">{{item.name}}: <strong>{{getTextOfBooleanValue(item.value)}}</strong></div>
													</div>
      </span>
      <span v-else>
      <img class="is_set" src="../../../assets/images/is-set.svg" alt="Ano"
           v-if="entity.enabled"/>
      <img v-else class="is_set" src="../../../assets/images/isnot-set.svg" alt="Ne"/>
      </span>
    </td>
    <td :data-th="'Timeshift' | translate">
      <img class="is_set" src="../../../assets/images/is-set.svg" alt="Ano"
           v-if="entity.allow_ts"/>
      <img v-else class="is_set" src="../../../assets/images/isnot-set.svg" alt="Ne"/>
    </td>
    <td :data-th="'Catchup' | translate">
      <img class="is_set" src="../../../assets/images/is-set.svg" alt="Ano"
           v-if="entity.allow_catchup"/>
      <img v-else class="is_set" src="../../../assets/images/isnot-set.svg" alt="Ne"/>
    </td>
    <td :data-th="'PVR' | translate">
      <img class="is_set" src="../../../assets/images/is-set.svg" alt="Ano"
           v-if="entity.allow_pvr"/>
      <img v-else class="is_set" src="../../../assets/images/isnot-set.svg" alt="Ne"/>
    </td>
    <td :data-th="'Povolené regiony' | translate">
      {{ allowedRegionsText(entity.allowed_regions, entity.restricted_regions) }}
    </td>
    <td :data-th="'Zakázané regiony' | translate">
      {{ restrictedRegionsText(entity.allowed_regions, entity.restricted_regions) }}
    </td>
    <td :data-th="'Upraveno' | translate" v-html="$_date_formatFull(entity.date_updated)"></td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a
            v-if="!entity.enabled && enableEditable"
            class="btn btn_action btn_grey btn_enable"
            :title="'Aktivovat' | translate"
            @click.prevent.stop="emitUpdateEntity({enabled: true, updateGlobalOnlyEnabled: true})"
            v-translate>Aktivovat
        </a>
        <a
            v-if="entity.enabled && enableEditable"
            class="btn btn_action btn_grey btn_disable"
            :title="'Deaktivovat' | translate"
            @click.prevent.stop="emitUpdateEntity({enabled: false, updateGlobalOnlyEnabled: true})"
            v-translate>Deaktivovat
        </a>
        <a
            v-if="$_deleteActionAllowed && !entity.id_remote"
            class="btn btn_action btn_delete"
            :title="'Smazat' | translate"
            @click.prevent.stop="emitDeleteEntity"
            v-translate>Smazat
        </a>
      </div>
    </td>
  </tr>
  </tbody>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"
import { getStateNameByIsoCode } from "../../../utils/helpers";
import EntityLink from "../../common/EntityLink.vue";

export default {
  name: "TagsRow",
  components: { EntityLink },
  mixins: [rowActions],
  props: {
    entity: Object,
  },
  data() {
    return {
      detailPageRouteName: "blackoutContentDetail",
    }
  },
  computed: {
    epgChannels() {
      return this.entity.all_epg_channels.join(', ');
    },
    enableEditable() {
      return this.$_updateActionAllowed && !this.entity.id_remote;
    },
  },
  methods: {
    getTextOfBooleanValue(value){
      if(value){
        return this.$gettext('Ano');
      }else{
        return this.$gettext('Ne');
      }
    },
    getRegionsList(data){
      return data.map((item) => {
        return getStateNameByIsoCode(item, this);
      });
    },
    allowedRegionsText(allowed, restricted){
      if(allowed.length === 0 && restricted.length === 0){
        return this.$gettext('Žádný');
      }else if(allowed.length === 0 && restricted.length > 0) {
        return "";
      }else {
        return this.getRegionsList(allowed).join(', ');
      }
    },
    restrictedRegionsText(allowed, restricted){
      if(allowed.length === 0 && restricted.length === 0){
        return this.$gettext('Všechny');
      }else if(allowed.length > 0 && restricted.length === 0){
        return "";
      }else{
        return this.getRegionsList(restricted).join(', ');
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/blackoutContents/BlackoutContentRow.vue